import { API } from './../constants'
import authService from './auth.js'
let inscriptos = null

const samyogaService = {
  async traerInscriptosSamyoga () {
    const fetchResponse = await fetch(`${API}/samyoga-inscriptos`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    inscriptos = respuesta.data
    return [...inscriptos]
  },
  crearInscripcion (data) {
    return fetch(`${API}/crear-inscripcion-samyoga`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  async checkInscripcionSamyoga (id1, id2) {
    const fetchResponse = await fetch(`${API}/check-inscripcion-samyoga/${id1}/${id2}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  }
}

export default samyogaService
